export default "__VITE_ASSET__PuZxJ_$N__"